module.exports = __webpack_public_path__ + "SMART-logo.png";